import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/ConfirmClosedMode.css';

export default function ConfirmClosedMode({ open, close, formState, closedModeData, updateClosedMode }) {
  const t = useTranslations('common.user_settings.closed_mode.confirmation');
  const [loading, setLoading] = useState(false);

  async function openGallery() {
    setLoading(true);

    const { response, data } = await GalleryService.updateClosedMode(false, "");

    if(response.ok) {
      setLoading(false);
      updateClosedMode(data);
      close();
    }
  }

  async function closeGallery() {
    setLoading(true);

    const { response, data } = await GalleryService.updateClosedMode(true, formState);

    if(response.ok) {
      setLoading(false);
      updateClosedMode(data);
      close();
    }
  }

  return (
    <>
      <GenericPopup
        open={open}
        className="confirm-closed-mode__popup"
        opacity
      >
        <div className="confirm-closed-mode__header">
          <Text className="confirm-closed-mode__header-text">
            {t('title')}
          </Text>

          <XIcon className="confirm-closed-mode__close" onClick={close}/>
        </div>

        {
          closedModeData ?
            <>
              <Text className="confirm-closed-mode__text" paragraph justify>
                {t('open_message')}
              </Text>

              <ContinueButton 
                className="font-size-medium confirm-closed-mode__button" 
                loading={loading} 
                onClick={openGallery}
              >
                {t('open_button')}
              </ContinueButton>
            </>
            :
            <>
              <Text className="confirm-closed-mode__text" paragraph justify>
                {t('close_message')}
              </Text>

              <ContinueButton 
                className="font-size-medium confirm-closed-mode__button" 
                loading={loading} 
                onClick={closeGallery}
              >
                {t('close_button')}
              </ContinueButton>
            </>
        }
      </GenericPopup>
    </>
  );
}
